import React from 'react';
import { Link } from 'react-router-dom';
import searchIcon from '@/assets/icons/search.svg';
import bellIcon from '@/assets/icons/bell.svg';
import ProfileDropdown from '@/components/molecules/ProfileDropdown';
import { useAppSelector } from '@/hooks/useAppSelector';
import { useBreadcrumbs } from '@/hooks/useBreadcrumbs';

const DashboardHeader = ({}) => {
  const currentUser = useAppSelector((state) => state.auth.currentUser);
  const isAdmin = currentUser?.roles?.includes('ADMIN');

  const breadcrumbItems = useBreadcrumbs();

  return (
    <header className="sticky w-full top-0 z-40 h-[64px] shadow-[0px_2px_4px_0px_#00000040] bg-white flex items-center justify-between px-7">
      {/* BREADCRUMBS */}
      <div className="flex items-center">
        <nav className="flex items-center" aria-label="Breadcrumb">
          <ol className="flex items-center flex-wrap">
            {breadcrumbItems.map((crumb, index) => {
              const isLast = index === breadcrumbItems.length - 1;
              const isFirst = index === 0;
              const isClickable = !isLast && !crumb.isEllipsis && crumb.path !== '';

              return (
                <li key={index} className="flex items-center">
                  {!isFirst && <span className="mx-2 text-gray-400">{'>'}</span>}

                  <div className="flex items-center">
                    {isFirst && crumb.icon && (
                      <img src={crumb.icon} alt={`${crumb.title.toLowerCase()} icon`} className="mr-2 h-5 w-5" />
                    )}

                    {isClickable ? (
                      <Link
                        to={crumb.path}
                        className="text-gray-500 font-semibold hover:text-primary hover:underline capitalize"
                      >
                        {crumb.title}
                      </Link>
                    ) : (
                      <span
                        className={`font-semibold capitalize ${
                          crumb.isEllipsis ? 'text-gray-400 cursor-default' : 'text-gray'
                        }`}
                      >
                        {crumb.title}
                      </span>
                    )}
                  </div>
                </li>
              );
            })}
          </ol>
        </nav>
      </div>

      <div className="flex items-center gap-9">
        {/* NOTIFICATIONS BELL */}
        {!isAdmin && (
          <button>
            <img src={bellIcon} alt="bell icon" />
          </button>
        )}

        {/* PROFILE DROPDOWN */}
        <ProfileDropdown />
      </div>
    </header>
  );
};

export default DashboardHeader;
